import { Router } from "express";

import { deviceController } from "../controllers/device-controller";
import { authenticate, createRateLimit } from "../middleware/auth-middleware";

const router = Router();

// Environment-aware rate limiting
const generalRateLimit = createRateLimit.general();

/**
 * @route   POST /api/v1/devices/register
 * @desc    Register or update device with FCM token
 * @access  Private (All authenticated users)
 * @body    deviceToken, deviceType, fcmToken, deviceName, deviceModel, osVersion, appVersion
 */
router.post("/register", authenticate, generalRateLimit, (req, res) =>
  deviceController.registerDevice(req, res),
);

/**
 * @route   PUT /api/v1/devices/:deviceId/fcm-token
 * @desc    Update FCM token for existing device
 * @access  Private (All authenticated users)
 * @body    fcmToken
 */
router.put("/:deviceId/fcm-token", authenticate, generalRateLimit, (req, res) =>
  deviceController.updateFCMToken(req, res),
);

/**
 * @route   GET /api/v1/devices
 * @desc    Get all devices for authenticated user
 * @access  Private (All authenticated users)
 * @query   includeInactive (optional)
 */
router.get("/", authenticate, generalRateLimit, (req, res) =>
  deviceController.getUserDevices(req, res),
);

/**
 * @route   DELETE /api/v1/devices/:deviceId
 * @desc    Deactivate a device
 * @access  Private (All authenticated users)
 */
router.delete("/:deviceId", authenticate, generalRateLimit, (req, res) =>
  deviceController.deactivateDevice(req, res),
);

/**
 * @route   POST /api/v1/devices/test-notification
 * @desc    Send test push notification to user's devices
 * @access  Private (All authenticated users)
 */
router.post("/test-notification", authenticate, generalRateLimit, (req, res) =>
  deviceController.testNotification(req, res),
);

/**
 * @route   GET /api/v1/devices/fcm-status
 * @desc    Get FCM service status
 * @access  Private (Admin only)
 */
router.get("/fcm-status", authenticate, generalRateLimit, (req, res) =>
  deviceController.getFCMStatus(req, res),
);

export default router;
